import { render, staticRenderFns } from "./UserHealthQuestion.vue?vue&type=template&id=6173c4c4&scoped=true&"
import script from "./UserHealthQuestion.vue?vue&type=script&lang=js&"
export * from "./UserHealthQuestion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6173c4c4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/coachingclub/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6173c4c4')) {
      api.createRecord('6173c4c4', component.options)
    } else {
      api.reload('6173c4c4', component.options)
    }
    module.hot.accept("./UserHealthQuestion.vue?vue&type=template&id=6173c4c4&scoped=true&", function () {
      api.rerender('6173c4c4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/vue/components/Admin/Users/Children/UserHealthQuestion.vue"
export default component.exports